import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { toast } from '../../toast/Toast';
import FastAPIInstance from '../../../services/risksystem3-public-api';

type AffectedDocsPayload = {
  template_updates?: any;
};

export function useGetAffectedDocuments(
  options?: UseMutationOptions<
    AxiosResponse<any>, // TData
    AxiosError<any>, // TError
    AffectedDocsPayload // TVariables
  >,
) {
  return useMutation({
    mutationFn: (payload: AffectedDocsPayload) =>
      getDocumentsAffectedByTemplateChanges(payload),

    onError: (error) => {
      toast({
        title: 'Failed to retrieve affected documents.',
        message: error.message,
        type: 'error',
      });
      console.error('Template impact fetch failed:', error);
    },
    ...options,
  });
}

export const getDocumentsAffectedByTemplateChanges = async (payload: {
  template_updates?: any;
}): Promise<AxiosResponse<any>> => {
  return await FastAPIInstance.post(
    'v1/raidr/get_documents_affected_by_template_changes',
    payload,
    {
      headers: { 'Content-Type': 'application/json' },
    },
  );
};
